import { Button, Form, Input } from 'antd'
import { memo, useCallback } from 'react'
import { LeagueFormat } from 'types/league-formats'

type Props = {
    leagueFormat: LeagueFormat
    onSubmit: (leagueFormat: LeagueFormat) => void
    loading: boolean
}

export const LeagueFormatForm = memo((props: Props) => {
    const { leagueFormat, onSubmit, loading } = props

    const onFinish = useCallback(
        (values: LeagueFormat) => {
            onSubmit(values)
        },
        [onSubmit]
    )

    return (
        <Form
            name='basic'
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete='off'
            disabled={loading}
        >
            <Form.Item
                initialValue={leagueFormat.name}
                label='Name'
                name='name'
                rules={[{ required: true, message: 'Please input league format name!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type='primary' htmlType='submit'>
                    Submit
                </Button>
                <Button htmlType={'reset'}>Reset</Button>
            </Form.Item>
        </Form>
    )
})
